import {
  LayoutDashboard, FolderOpen, Plus, MessageSquare, FileText,
  Bell, User, Shield, Users, UserCog, ScrollText,
  Settings, Inbox, Newspaper, ArrowDownToLine, ArrowUpFromLine, Receipt, Wallet,
} from "lucide-react";

export const CLIENT_NAV = [
  { to: "/portal", label: "Panoramica", label_en: "Overview", label_de: "Übersicht", icon: LayoutDashboard, end: true },
  { to: "/portal/cases", label: "Le mie pratiche", label_en: "My cases", label_de: "Meine Fälle", icon: FolderOpen },
  { to: "/avvia-recupero", label: "Nuova pratica", label_en: "New case", label_de: "Neuer Fall", icon: Plus },
  { to: "/portal/deposit", label: "Deposito", label_en: "Deposit", label_de: "Einzahlung", icon: ArrowDownToLine },
  { to: "/portal/withdraw", label: "Prelievo", label_en: "Withdraw", label_de: "Auszahlung", icon: ArrowUpFromLine },
  { to: "/portal/transactions", label: "Transazioni", label_en: "Transactions", label_de: "Transaktionen", icon: Receipt },
  { to: "/portal/messages", label: "Messaggi", label_en: "Messages", label_de: "Nachrichten", icon: MessageSquare },
  { to: "/portal/documents", label: "Documenti", label_en: "Documents", label_de: "Dokumente", icon: FileText },
  { to: "/portal/notifications", label: "Notifiche", label_en: "Notifications", label_de: "Benachrichtigungen", icon: Bell },
  { to: "/portal/profile", label: "Profilo", label_en: "Profile", label_de: "Profil", icon: User },
  { to: "/portal/security", label: "Sicurezza", label_en: "Security", label_de: "Sicherheit", icon: Shield },
];

export const SPECIALIST_NAV = [
  { to: "/specialist", label: "Coda di lavoro", label_en: "Work queue", label_de: "Arbeitswarteschlange", icon: LayoutDashboard, end: true },
];

export const ADMIN_NAV = [
  { to: "/admin", label: "Panoramica", label_en: "Overview", label_de: "Übersicht", icon: LayoutDashboard, end: true },
  { to: "/admin/leads", label: "Lead", label_en: "Leads", label_de: "Leads", icon: Inbox },
  { to: "/admin/clients", label: "Clienti", label_en: "Clients", label_de: "Kunden", icon: Users },
  { to: "/admin/cases", label: "Pratiche", label_en: "Cases", label_de: "Fälle", icon: FolderOpen },
  { to: "/admin/specialists", label: "Specialisti", label_en: "Specialists", label_de: "Spezialisten", icon: UserCog },
  { to: "/admin/deposits", label: "Depositi", label_en: "Deposits", label_de: "Einzahlungen", icon: ArrowDownToLine },
  { to: "/admin/withdrawals", label: "Prelievi", label_en: "Withdrawals", label_de: "Auszahlungen", icon: ArrowUpFromLine },
  { to: "/admin/transactions", label: "Transazioni", label_en: "Transactions", label_de: "Transaktionen", icon: Receipt },
  { to: "/admin/content", label: "Contenuti", label_en: "Content", label_de: "Inhalte", icon: Newspaper },
  { to: "/admin/audit", label: "Log di audit", label_en: "Audit log", label_de: "Audit-Protokoll", icon: ScrollText },
  { to: "/admin/settings", label: "Impostazioni", label_en: "Settings", label_de: "Einstellungen", icon: Settings },
];

export function navLabel(item, lang) {
  if (lang === "en") return item.label_en || item.label;
  if (lang === "de") return item.label_de || item.label_en || item.label;
  return item.label;
}
